import { Widgets } from '@material-ui/icons';
import { joinChannel } from './../../../redux/actions/programAction';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    drawer: {
        width: 500,
        flexShrink: 0,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },

    drawerPaper: {
        width: 500,

        [theme.breakpoints.down("sm")]: {
            width: "100%",
          },
         
    },
    profileDrawerPaper: {
        width: 350,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 150px)", 
        },
          [theme.breakpoints.down("md")]: {
            width: "calc(100% - 115px)", 

          },

    },
    activeItem: {
        background: "#376cdf",
        color: "white",
        "&:hover": {
            background: "#376cdf",
            color: "white",
        },
    },
    

    addChannel:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        gap:'10px',
        cursor:'pointer'
    },

    logo: {
        fontWeight: 500,
        textDecoration: "none",
        color: '#FFB819'
    },
    avatar: {
        marginRight: theme.spacing(2),
        width: theme.spacing(7),
        height: theme.spacing(7),
        borderRadius: "50% !important"
    },
    listItem: {
        textTransform: 'capitalize',
        borderRadius: 8,
        '&.active': {
            backgroundColor: '#232222',
            color: '#ffffff',
        },
    },
    listItemText: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontSize: '14px',
        marginLeft: theme.spacing(1),
        '&.active': {
            backgroundColor: '#232222',
            color: '#ffffff',
        },
        "& .MuiListItemText-primary": {
            color: "#2158D0",
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontWeight: "700",
            Size: "16px",
            LineHeight: '20.15px'
        },

    },
    nested: {
        paddingLeft: theme.spacing(4),
        '&.active': {
            backgroundColor: '#232222',
            color: '#ffffff',
        },
    },
    innernested: {
        paddingLeft: theme.spacing(6),
        '&.active': {
            backgroundColor: '#232222',
            color: '#ffffff',
        },
    },
    search: {
        position: 'relative',
        borderRadius: 8,
        backgroundColor: theme.palette.action.hover,
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
    },
    grey: {
        color: '#00000099',
        fontSize: "12px"
    },
    profileName: {
        color: "#2158D0",
        fontWeight: 700,
        textTransform: 'capitalize',
        fontSize: "16px"

    },
    list: {
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 5,
        paddingRight: 5
    },
    input: {
        fontSize: "14px"
    },
    hamburgerButton: {
        position: 'absolute',
        top: 0,
        left: theme.spacing(1),
    },
    logoWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItem: "center"
    },
    logoImage: {
        width: 234,
        height: 70,
        marginRight: 50
    },
    channelTitle: {
        color: "#2158D0",
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontSize: "18px",
        fontWeight: 700,
        lineHeight: "20.15px",
        cursor:'pointer'
    },
    channelSmallTitle: {
        color: "#2158D0",
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        fontSize: "15px",
        fontWeight: 400,
        lineHeight: "20.15px"
    },
    description: {
        color: "red",
        backgroundColor: "green"
    },
    textWrapper: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    timestamp: {
        color: "#999",
        fontSize: "12px",
        marginTop: "4px",
    },
    listItemWrapper: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "8px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        backgroundColor: "#fff",
        transition: "0.3s ease-in-out",
        "&:hover": {
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        },
    },
    hasNotification: {
        position: 'absolute',
        top: '14px',
        left: '50px',
        width: '15px',
        height: '15px',
        backgroundColor: '#1976D2',
        borderRadius: '50%',
    },
    listItemImage: {
        width: "50px",
        height: "50px",
        borderRadius: "8px",
        objectFit: "cover",
        marginRight: "10px",
    },
    divider: {
        width: "2px",
        height: "40px",
        backgroundColor: "#00000033",
        margin: "0 10px",
    },
    communityIdentifier:{
        fontSize: "20px",
        fontWeight: 700,
        textTransform: 'capitalize',
    },
    closeProfileDrawerButton:{
        marginTop: '20px',
        width:"80px"
    },
    sideBarCollapse:{
      maxHeight: "430px", 
      overflow: "scroll" ,
      scrollbarWidth: "thin",
      [theme.breakpoints.down("sm")]: {
        maxHeight: "230px",
    },
},
viewMorebtn:{
            backgroundColor: "#1669C1!important",
            color: "#FFF",
            borderRadius: "8px",
            padding: "6px 16px",
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "none",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            width:"150px",
            justifyContent: "space-evenly",
            "&:hover": { backgroundColor: "#1669C1" },
          
  },

  transparentDialog: {
    backgroundColor: 'transparent', // Remove Dialog background
    boxShadow: 'none', // Remove shadow
    padding: 0,
    margin: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden', 
  },
  dialogContent: {
    width: '100%',
    height: '100%',
    overflow: 'hidden', // Ensures no scrolling
  },
  activeChannel:{
    backgroundColor: 'transparent !important' ,
    boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2), 0px -5px 10px rgba(0, 0, 0, 0.2) !important", 

}
}));